import { default as domainSmartshare } from './smartshare/services' 
import { default as domainIntegration } from './integration/services'
import { default as domainIntegrationAzureAd } from './azure-ad/services'

export default { 
	domainSmartshare,
	domainIntegration,
	domainIntegrationAzureAd
}
